import * as React from 'react'
import * as st from './ChannelLogo.module.scss'

export const ChannelLogo = ({ url, name }: { url: string, name: string }) => {
    return <img className={st.channelLogo} src={url} alt={name} />
}